<main class="main mt-3">
  <div class="content">
    <div class="left-side" *ngIf="!isPreview">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>Descriptions ({{ keys.length }}/{{ maxVariables }}):</div>
      </div>
      <div class="row">
        <div class="col-12" *ngFor="let descriptionKey of keys">
          <app-block-text
            [type]="'content'"
            [isPlainText]="true"
            [restrictContent]="true"
            (handleOnChange)="onChange($event, descriptionKey)"
            (handleVariableRemoval)="variableRemoval($event)"
            [blockData]="block.variables?.[descriptionKey] ?? ''"
            [maxLength]="90"
            [variable]="descriptionKey"
            [blockId]="block.blockId"
            [isSubBlockDeletable]="true"
          ></app-block-text>
        </div>
        <div class="col-12 mt-2">
          <button
            type="button"
            class="btn btn-outline-primary btn-sm"
            (click)="add()"
            [disabled]="!canAdd"
          >
            <i class="bi bi-plus-lg"></i> Add Description
          </button>
        </div>
      </div>
    </div>
    <!-- <div
      class="right-side-container"
      [id]="block.blockId"
      (click)="onContainerClick($event)"
    >
      <app-pin [block]="block"></app-pin>
      <div class="right-side">
        <div class="row text-center">
          <div class="col-12" [innerHTML]="block.variables?.['Description_1']"></div>
        </div>
      </div>
    </div> -->
    <!-- <div class="comments-side" *ngIf="!isPreview">
      <app-notification
        [notifications]="block.notifications"
        [blockId]="block.blockId"
      ></app-notification>
    </div> -->
  </div>
</main>
